import axios from 'axios';

const BASE_URL = 'https://hhweborderingapimanagmentdev.azure-api.net';

const instance = axios.create({
  baseURL: BASE_URL,
});

export default instance;
